var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{on:{"click":function($event){_vm.showModal = true}}},[_vm._t("default")],2),(_vm.showModal)?_c('early-tiger-store',{attrs:{"early_tiger":_vm.early_tiger},on:{"reload":_vm.reload,"closeModal":function($event){_vm.showModal = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }